<template>
  <div class="create-payment">
    <div class="create-payment__data">
      <div class="create-payment__field">
        <text-input
            view="line"
            name="full_name"
            v-model="client.full_name"
            :errors="v$.client.full_name.$errors"
            :title="$t('create_payment.full_name.title')"
            :placeholder="$t('create_payment.full_name.placeholder')"
        ></text-input>
      </div>
      <!--      <div class="create-payment__field create-payment__field&#45;&#45;with-padding">-->
      <!--        <checkbox-input-->
      <!--          :title="$t('create_payment.is_payment_from_jur')"-->
      <!--        ></checkbox-input>-->
      <!--      </div>-->
      <div class="create-payment__field">
        <div class="identifier-block">
          <text-input
              view="line"
              name="inn"
              v-model="client.inn"
              :errors="v$.client.inn.$errors"
              :title="$t('create_payment.identifier.title')"
              :placeholder="$t('create_payment.identifier.placeholder')"
          ></text-input>
          <div class="create-payment__field-error" v-if="isInvalidIdentifier">
            {{ $t("create_payment.identifier.invalid_repeat_digits") }}
          </div>
        </div>
      </div>

      <div
          class="create-payment__field create-payment__field--select"
          :class="{
          'create-payment__field--error':
            v$.selectedPaymentType.$errors.length > 0,
        }"
      >
        <div class="create-payment__field-label">
          {{ $t("create_payment.payment_type.title") }}
        </div>
        <div class="create-payment__field-block">
          <v-select
              v-model="selectedPaymentType"
              :options="paymentTypesDataSet"
              :placeholder="$t('create_payment.payment_type.placeholder')"
          ></v-select>
          <div
              class="create-payment__field-errors"
              v-if="v$.selectedPaymentType.$errors.length > 0"
          >
            <div class="create-payment__field-error">
              {{ v$.selectedPaymentType.$errors[0].$message }}
            </div>
          </div>
        </div>
      </div>
      <create-payment-additional-fields
          ref="createPaymentAdditionalFields"
          :payment-type="selectedPaymentType"
          v-model="additionalFieldsData"
          v-if="additionalFieldsActive"
          :repeat-order-object="repeatOrderObject"
          :external-errors="vuelidateExternalResults"
          :client="client"
          @repeatOrderSet="clearRepeatOrderObject"
      ></create-payment-additional-fields>
      <div
          class="create-payment__group-title"
          v-if="
          selectedPaymentType &&
          selectedPaymentType.slug === paymentTypesConst.adminPayment
        "
      >
        {{ $t("your_requisites_for_percents_back") }}
      </div>
      <div
          class="create-payment__field"
          v-if="
          selectedPaymentType &&
          selectedPaymentType.slug === paymentTypesConst.adminPayment
        "
      >
        <text-input
            view="line"
            v-model="okpo"
            name="okpo"
            :title="$t('create_payment.okpo.title')"
            :placeholder="$t('create_payment.okpo.placeholder')"
            :mask="'XXXXXXXXXX'"
            :errors="v$.okpo && v$.okpo.$errors"
        ></text-input>
      </div>
      <div
          class="create-payment__field"
          v-if="
          selectedPaymentType &&
          selectedPaymentType.slug === paymentTypesConst.adminPayment
        "
      >
        <text-input
            view="line"
            v-model="iban"
            name="iban"
            :title="$t('create_payment.iban.title')"
            :placeholder="$t('create_payment.iban.placeholder')"
            :mask="'UA#############################'"
            :errors="v$.iban && v$.iban.$errors"
        ></text-input>
      </div>
      <div class="create-payment__field create-payment__field--amount">
        <text-input
            view="line"
            v-model="amount"
            name="sum"
            :title="$t('create_payment.sum.title')"
            :placeholder="$t('create_payment.sum.placeholder')"
            :mask="currencyMask"
            class=""
        ></text-input>
        <div class="create-payment__field-descr">
          <div class="commission">
            {{ $t("create_payment.commission", {
            commissionPercents: $options.COMMISSION_PERCENTS,
            commissionMinAmount: $options.COMMISSION_MIN_AMOUNT_UAH,
          })
            }}
          </div>
<!--          <div class="warning-text">-->
<!--            {{ $t("create_payment.warning_text") }}-->
<!--          </div>-->
        </div>
      </div>
    </div>
    <div class="create-payment__total">
      <div class="create-payment__total-title">
        {{ $t("create_payment.total.title") }}
      </div>
      <div class="create-payment__total-amount">
        {{ amountWithCommission }} {{ $t("create_payment.total.currency") }}
      </div>
    </div>
    <div class="create-payment__actions">
      <primary-button
          :text="$t('create_payment.add_to_cart')"
          class="create-payment__action"
          @click="createPayment"
          :disabled="isInvalidIdentifier"
      ></primary-button>
      <transparent-button
          :text="$t('create_payment.reset')"
          class="create-payment__action"
      ></transparent-button>
    </div>
  </div>
</template>

<script>
import TextInput from "@/components/inputs/TextInput";
// import CheckboxInput from "@/components/inputs/CheckboxInput";
import PrimaryButton from "@/components/buttons/PrimaryButton";
import TransparentButton from "@/components/buttons/TransparentButton";
import { PaymentTypeApi } from "@/office/payment/payment-type-api";
import { CartApi } from "@/office/cart/cart-api";
import CreatePaymentAdditionalFields from "@/components/payment/CreatePaymentAdditionalFields";

import createNumberMask from "text-mask-addons/dist/createNumberMask";
import { LOAD_USER_DATA, UPDATE_CART_ITEMS_COUNT } from "@/store/action-types";

import useVuelidate from "@vuelidate/core";
import { required, helpers } from "@vuelidate/validators";
import { ibanBalanceByOkpo } from "@/validators/custom";

const identifierFormat = helpers.withParams(
    { type: 'identifierFormat' },
    value => {
      if (!helpers.req(value)) return true;
      const cleaned = String(value).trim().toUpperCase()
          .replace(/\s+/g, '');

      return /^(\d{10}|\d{9}|\d{8}|[А-ЯІЇЄ]{2}\d{6})$/.test(cleaned);
    }
);

const fullNameWords = helpers.withParams(
    { type: 'fullNameWords' },
    value => {
      if (!helpers.req(value)) return true;
      const words = value.trim().split(/\s+/);
      return words.length >= 2;
    }
);

const noForbiddenNameChars = helpers.withParams(
    { type: 'noForbiddenNameChars' },
    value => {
      if (!helpers.req(value)) return true;
      return !/[a-zA-ZъыэёЪЫЭЁ]/.test(value);
    }
);

const notSame10Digits = helpers.withParams(
    { type: 'notSame10Digits' },
    value => !(value && value.length === 10 && /^(\d)\1{9}$/.test(value))
);

import {
  ADMIN_GOVERNMENT_PAYMENT,
  ADMIN_PAYMENT,
  REGISTRY_PAYMENT,
  REQUISITES_PAYMENT,
} from "@/const/payment-types";
import { mapGetters } from "vuex";
import { OrderApi } from "@/office/order/order-api";
import {
  COMMISSION_DECIMAL,
  COMMISSION_PERCENTS,
  COMMISSION_MIN_AMOUNT_UAH,
} from "@/const/config";

const currencyMask = createNumberMask({
  prefix: "",
  allowDecimal: true,
  includeThousandsSeparator: false,
  allowNegative: false,
  locale: "ru",
});

export default {
  name: "CreatePayment",
  components: {
    CreatePaymentAdditionalFields,
    TransparentButton,
    PrimaryButton,
    // CheckboxInput,
    TextInput,
  },
  setup() {
    return {
      v$: useVuelidate(),
    };
  },
  validations() {
    const validationsObject = {
      client: {
        inn: {
          required: helpers.withMessage('client_inn_required', required),
          identifierFormat: helpers.withMessage('client_inn_format_invalid', identifierFormat),
          notSame10Digits: helpers.withMessage('client_inn_same_digits', notSame10Digits),
        },
        full_name: {
          required: helpers.withMessage('client_full_name_required', required),
          fullNameWords: helpers.withMessage(() => this.$t('create_payment.full_name.min_words'), fullNameWords),
          noForbiddenNameChars: helpers.withMessage('client_full_name_forbidden_chars', noForbiddenNameChars),
        },
      },
      selectedPaymentType: {
        required: helpers.withMessage('payment_type_required', required),
      },
    };

    const res = { ...validationsObject };
    const slug = this.selectedPaymentType && this.selectedPaymentType.slug;

    if (slug === this.paymentTypesConst.adminPayment) {
      res.iban = {
        required: helpers.withMessage('your_iban_required', required),
        ibanBalanceByOkpo: helpers.withMessage(
            'iban_balance_code_by_okpo_rule',
            ibanBalanceByOkpo(() => this.okpo)
        ),
      };
      res.okpo = {
        required: helpers.withMessage('your_okpo_required', required),
      };
    }

    return res;
  },

  data() {
    return {
      paymentTypesConst: {
        adminPayment: ADMIN_PAYMENT,
        registryPayment: REGISTRY_PAYMENT,
        requisitesPayment: REQUISITES_PAYMENT,
        adminGovernmentPayment: ADMIN_GOVERNMENT_PAYMENT,
      },
      repeatOrderObject: null,
      paymentTypes: [],
      selectedPaymentType: null,
      additionalFieldsActive: false,
      additionalFieldsData: {},
      amount: 0,
      okpo: "",
      iban: "",
      client: {
        inn: "",
        full_name: "",
      },
      currencyMask,
      vuelidateExternalResults: {
        purpose: [],
      },
    };
  },
  COMMISSION_PERCENTS,
  COMMISSION_MIN_AMOUNT_UAH,
  created() {
    this.loadPaymentTypes();
    this.setUserFields();

    if (this.$route.query.repeat_item_id) {
      new OrderApi()
          .loadOrderItemRepeatData(this.$route.query.repeat_item_id)
          .then((r) => {
            let orderItem = r.data.order_item;
            let paymentData = r.data.payment_data;

            this.client.inn = orderItem.order.client.inn;
            this.client.full_name = orderItem.order.client.full_name;

            this.selectedPaymentType = {
              id: paymentData.payment_type.id,
              label: this.$t(paymentData.payment_type.slug),
              slug: paymentData.payment_type.slug,
            };

            this.repeatOrderObject = {
              orderItem: orderItem,
              paymentData: paymentData,
            };
            this.amount = this.repeatOrderObject.orderItem.sum_base;
          });
      this.$router.replace({ query: {} });
    } else if (this.$route.query.client) {
      let _client = JSON.parse(this.$route.query.client);

      this.client.inn = _client.inn;
      this.client.full_name = _client.full_name;
    } else {
      this.loadLastClient();
    }
  },
  watch: {
    selectedPaymentType: function () {
      if (this.selectedPaymentType === null) {
        this.resetFields();
      } else {
        this.additionalFieldsActive = true;
      }
    },
    additionalFieldsData: function () {
      if (
          this.selectedPaymentType.slug !==
          this.paymentTypesConst.requisitesPayment ||
          (this.additionalFieldsData.requisites_template !== null &&
              this.additionalFieldsData.requisites_template.id !== null) ||
          (this.additionalFieldsData.requisites_template !== null &&
              this.additionalFieldsData.requisites_template.id !== "reset")
      ) {
        this.amount = this.additionalFieldsData.amount;
      }
    },
    userData: function () {
      this.setUserFields();
    },
  },
  methods: {
    clearRepeatOrderObject() {
      this.repeatOrderObject = null;
    },
    loadPaymentTypes() {
      new PaymentTypeApi().getPaymentTypes().then((r) => {
        this.paymentTypes = r.data.payment_types;
        this.selectedPaymentType = this.paymentTypesDataSet[0];
      });
    },
    async createPayment() {
      this.v$.$touch();
      const isValid = await this.v$.$validate();

      if (!isValid) {
        return;
      }

      const isAdditionalFieldsValid =
          await this.$refs.createPaymentAdditionalFields.validate();

      if (!isAdditionalFieldsValid) {
        return;
      }

      if (
          this.selectedPaymentType.slug ===
          this.paymentTypesConst.requisitesPayment
      ) {
        let _purposeIncludesInn = 0;
        [this.client.inn, this.userData.inn].forEach((_inn) => {
          if (this.additionalFieldsData.purpose.includes(_inn)) {
            _purposeIncludesInn++;
          }
        });

        if (_purposeIncludesInn === 0) {
          Object.assign(this.vuelidateExternalResults, {
            purpose: ["purpose_must_contains_ipn"],
          });
          return;
        }
      }

      let _paymentData = {
        client: {
          inn: this.client.inn,
          full_name: this.client.full_name,
        },

        sum: this.amount,
        payment_type_id: this.selectedPaymentType.id,
        ...this.additionalFieldsData,
        okpo:
            this.additionalFieldsData.okpo === null
                ? this.okpo
                : this.additionalFieldsData.okpo,
        iban:
            this.additionalFieldsData.iban === null
                ? this.iban
                : this.additionalFieldsData.iban,
        amount: this.amount,
      };
      new CartApi().addPaymentToCart(_paymentData).then(async (r) => {
        await this.$store.dispatch(UPDATE_CART_ITEMS_COUNT, r.data.items_count);
        await this.$store.dispatch(LOAD_USER_DATA);
        this.resetFields();
      });
    },
    resetFields() {
      this.additionalFieldsActive = false;

      this.selectedPaymentType = null;
      this.v$.$reset();
      this.amount = 0;
    },
    setUserFields() {
      this.okpo = this.userData.okpo;
      this.iban = this.userData.iban;
    },
    loadLastClient() {
      new CartApi().loadLastClient().then((r) => {
        if (r.data.client) {
          this.client.inn = r.data.client.inn;
          this.client.full_name = r.data.client.full_name;
        }
      });
    },
  },
  computed: {
    ...mapGetters(["userData"]),
    paymentTypesDataSet() {
      return this.paymentTypes.map((pT) => ({
        id: pT.id,
        label: this.$t(pT.slug),
        slug: pT.slug,
      }));
    },
    amountWithCommission() {
      let commission = 0;

      if (this.amount > 0) {
        if (
            this.selectedPaymentType.slug === this.paymentTypesConst.adminPayment
        ) {
          let _firstCommission = this.amount * 0.6 * COMMISSION_DECIMAL;
          let _secondCommission = this.amount * 0.4 * COMMISSION_DECIMAL;

          if (_firstCommission < COMMISSION_MIN_AMOUNT_UAH) {
            _firstCommission = COMMISSION_MIN_AMOUNT_UAH;
          }

          if (_secondCommission < COMMISSION_MIN_AMOUNT_UAH) {
            _secondCommission = COMMISSION_MIN_AMOUNT_UAH;
          }

          commission = _firstCommission + _secondCommission;

        } else {
          commission = this.amount * COMMISSION_DECIMAL;

          if (commission < 10) {
            commission = 10;
          }
        }

        let _amount = parseFloat(this.amount) + commission;
        return Math.round((_amount + Number.EPSILON) * 100) / 100;
      }

      return this.amount;
    },

    isInvalidIdentifier() {
      const val = this.client.inn.trim();
      return /^(\d)\1{9}$/.test(val);
    }
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/_variables.scss";
@import "~@/assets/scss/_mixins.scss";

.create-payment {
  &__data {
    padding: 34px 126px 34px 25px;
    border: 1px solid #f0f3fa;
    border-radius: 0 0 16px 16px;
  }

  &__group {
    &-title {
      font-size: pxToRem(12);
      line-height: pxToRem(20);
      margin-top: 40px;
      margin-bottom: 25px;
      color: $textDark;
      font-weight: bold;
    }
  }

  &__field {
    width: 100%;
    display: flex;
    align-items: center;

    margin-bottom: 25px;

    &:last-child {
      margin-bottom: 0;
    }

    &-label {
      color: $textLight;
      font-size: pxToRem(10);
      line-height: pxToRem(12);
      margin-right: 50px;
      width: 116px;
      word-wrap: break-word;
      flex-shrink: 0;
      flex-grow: 0;
    }

    &--amount {
      display: flex;
      align-items: center;
    }

    &-descr {
      margin-left: 15px;
      color: $text;
      font-size: pxToRem(10);
      line-height: pxToRem(12);
    }
  }

  .identifier-block {
    width: 100%;

    .create-payment__field-error {
      text-align: center;
      color: #F27272;
    }
  }

  &__total {
    margin-top: 20px;
    border: 1px solid #f0f3fa;
    border-radius: 16px;
    padding: 32px 26px;
    display: flex;
    align-items: center;

    &-title {
      color: $textLight;
      font-size: pxToRem(10);
      line-height: pxToRem(12);
      width: 116px;
      margin-right: 60px;
    }

    &-amount {
      color: $green;
      font-weight: 600;
      font-size: pxToRem(16);
      line-height: pxToRem(20);
    }
  }

  &__actions {
    display: flex;
    align-items: center;
    padding-left: 140px;
    margin-top: 38px;
  }

  &__action {
    margin-right: 10px;

    &:last-child {
      margin-right: 0;
    }
  }
}
</style>

<style lang="scss">
@import "~@/assets/scss/_variables.scss";
@import "~@/assets/scss/_mixins.scss";
@import "~vue-select/src/scss/vue-select.scss";

.create-payment {
  &__field {
    &--error & {
      &-label {
        color: $red;
      }

      &-errors {
        position: absolute;
        bottom: 0;
      }

      &-error {
        color: $red;
        font-size: pxToRem(10);
        line-height: pxToRem(12);
      }
    }

    &--error {
      position: relative;
      padding-bottom: 16px;

      .vs__dropdown-toggle {
        border-color: $red;
      }
    }

    &-block {
      width: calc(100% - 166px);
      flex-shrink: 1;
      flex-grow: 1;
    }

    &--amount {
      .text-input {
        width: auto;

        &__el {
          width: 140px;
          max-width: 140px;
        }
      }
    }
  }
}

.v-select {
  width: 100%;
  flex-grow: 1;
  flex-shrink: 1;
}

.vs__dropdown-toggle {
  border: 1px solid #f0f3fa;
  box-sizing: border-box;
  border-radius: 6px;
  padding: 14px 16px;
}

.vs__selected-options {
  padding: 0;
  height: pxToRem(16);
  width: calc(100% - 16px);
}

.vs__selected {
  padding: 0 !important;
  margin: 0 !important;
  font-size: pxToRem(12) !important;
  line-height: pxToRem(15) !important;
  border: none !important;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  max-width: 100%;
  color: $text;
}

.vs__search {
  padding: 0 !important;
  margin: 0 !important;
  font-size: pxToRem(12) !important;
  line-height: pxToRem(16) !important;
  border: none !important;
  color: $text;
}

.vs__actions {
  padding-top: 0;
}

.vs__clear {
  display: none;
}
</style>
